import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './Widget.module.scss';
import WidgetHeaderControls from './WidgetHeaderControls';

const WidgetGraphe = ({
  graphesFavoris = [],
  onGrapheClick,
  headerContent = null,
  showHeader = true,
}) => {
  const hasGraphes = graphesFavoris && graphesFavoris.length > 0;
  const [selectedGrapheIndex, setSelectedGrapheIndex] = useState('0');
  const graphLength = graphesFavoris?.length || 0;
  const topBars = [72, 58, 80, 64, 92, 65, 78];
  const bottomBars = [55, 42, 63, 51, 70, 57, 48, 62, 59, 40];

  useEffect(() => {
    if (!hasGraphes) {
      setSelectedGrapheIndex('0');
      return;
    }

    const currentIndex = Number(selectedGrapheIndex);
    if (currentIndex >= graphLength) {
      setSelectedGrapheIndex('0');
    }
  }, [graphLength, hasGraphes, selectedGrapheIndex]);

  const grapheOptions = useMemo(() => {
    if (!hasGraphes || graphLength < 2) {
      return [];
    }

    return graphesFavoris.map((graphe, index) => ({
      value: String(index),
      label: graphe.graph_name || `${checkMot('graphe')} ${index + 1}`,
    }));
  }, [graphLength, graphesFavoris, hasGraphes]);

  const currentGraphe = hasGraphes
    ? graphesFavoris[Number(selectedGrapheIndex)] || graphesFavoris[0]
    : null;

  const resolvedHeader =
    headerContent ||
    (showHeader ? (
      <WidgetHeaderControls
        titleKey="graphe"
        selectOptions={grapheOptions}
        selectedValue={selectedGrapheIndex}
        onSelectChange={setSelectedGrapheIndex}
      />
    ) : null);
  
  return (
    <div className={[S.widget, S.widgetMedium].join(' ')}>
      {resolvedHeader}
      <div className={S.widgetContent}>
        {hasGraphes ? (
          <div className={S.grapheContainer}>
            <div className={S.grapheTitle}>
              {currentGraphe?.graph_name || 'Graphe'}
            </div>
            <div className={S.graphePreview}>
              <div className={S.chartStack}>
                <div className={S.barChart}>
                  {topBars.map((h, i) => (
                    <div 
                      key={`top-${i}`} 
                      className={S.bar} 
                      style={{ height: `${h}%` }}
                    />
                  ))}
                </div>
                <div className={[S.barChart, S.barChartSmall].join(' ')}>
                  {bottomBars.map((h, i) => (
                    <div 
                      key={`bottom-${i}`} 
                      className={S.bar} 
                      style={{ height: `${h}%` }}
                    />
                  ))}
                </div>
              </div>
            </div>
            {currentGraphe?.graph_id && (
              <Link 
                to={`/graphe/${currentGraphe.graph_id}`}
                className={S.widgetLink}
                onClick={() => onGrapheClick && onGrapheClick(currentGraphe)}
              >
                {checkMot('voir_plus')}
              </Link>
            )}
          </div>
        ) : (
          <div className={S.emptyState}>
            <div className={S.barChart}>
              {[40, 60, 30, 70, 50, 80, 45, 65, 35, 55, 75, 40].map((h, i) => (
                <div 
                  key={i} 
                  className={[S.bar, S.barEmpty].join(' ')} 
                  style={{ height: `${h}%` }}
                />
              ))}
            </div>
            <p className={S.emptyText}>{checkMot('aucun_graphe_favori')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WidgetGraphe;
